export default __webpack_public_path__ + "static/media/line-v-10.98b729a0.png";